import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Eroare in interfata:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-lg w-full rounded-xl bg-white p-6 shadow-2xl">
            <h3 className="text-lg font-bold text-red-700 mb-2">A apărut o eroare</h3>
            <p className="text-sm text-gray-700 mb-4">
              {this.props.message || 'Această secțiune nu a putut fi afișată. Restul aplicației funcționează normal.'}
            </p>
            <p className="text-xs font-mono bg-gray-100 rounded p-2 text-gray-600 mb-4 break-words">
              {String(this.state.error?.message || this.state.error)}
            </p>
            <button
              type="button"
              onClick={() => {
                this.setState({ error: null });
                if (this.props.onReset) this.props.onReset();
              }}
              className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white font-semibold hover:bg-blue-700"
              data-testid="error-boundary-close-btn"
            >
              Închide
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
